/**
 * Created by sswaminathan on 12/15/21
 * File: SubscriptionForm
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css


/**
 *   TODO: Brief what is this component/class do
 */
import { Form } from '@panwds/react-form-legacy'
import { LoadingIcon, useModal } from '@panwds/react-ui'
import { groupBy, toNumber } from 'lodash'
import { useCallback, useState } from 'react'
import { LoadAllInstanceData, LoadInstances, SubmitAllocation } from '../../../common/actions/GlobalActions'
import BreadCrumbs from '../../../common/components/breadcrumbs/BreadCrumbs'
import {
  APP_ID_DSS_ID, APP_ID_LOGGING_SERVICE, APP_ID_PRISMA_ACCESS,
  APP_ID_PRISMA_ACCESS_EDITION, APP_ID_SDWAN,
  VIEW_MANAGE_TENANT
} from '../../../common/constants/GlobalConstants'
import MessageBanner from '../../../common/banner/MessageBanner'
import { loadInstanceData, selectTreeNode } from '../../../common/reducers/actions/TreeReducer.actions'
import { setCurrentViewing } from '../../../common/utils/Sparky'
import {
  addNewTenantIdApps,
  ALLOCATION_ERROR_MSG,
  CALCULATED_FIELDS, CDL_ALERT_HEADER, FULL, SHARED,
  URL_VALIDATIONS,
  ALLOW_DISABLE_ADDONS, SUBSCRIPTION_ACTION_EDIT, CDL_ALERT_CONTENT, FULL_ALLOCATION,
} from '../constants/SubscriptionConstant'
import UsageAlertModel from '../modals/UsageAlertModel'
import SubscriptionManagement from './SubscriptionManagement'
import './subscriptionManagement.scss'

const SubscriptionForm = ({ breadcrumbs, onClick, selectedTreeNode, apps, ...props }) => {
  const [productInformation, setProductInformation] = useState({})
  const [cgxProductInfo, setCgxProductInfo] = useState({})
  const [isFormLoading, setFormLoading] = useState(false)
  const [showErrorMsg, setShowErrorMsg] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const { updatedLicenseInfo } = props.licenseReducer
  const cdlAlertModal = useModal(UsageAlertModel)

  const formatCgxRequest = useCallback((response, responsePayload) => {
    const cgxRequest = {}
    responsePayload.length > 0 && responsePayload.forEach((each) => {
      cgxRequest.request = { ...each.cgxRequest }
      if (response[`${cgxRequest.request.license_id}:cgx`]) {
        cgxRequest.request.region = response.region_name.id
        cgxRequest.request.tsg_name = selectedTreeNode.display_name
        cgxRequest.request.instances.forEach((each) => {
          each.description = response.description
        })
      }
      else {
        cgxRequest.request = {}
      }
    })
    return cgxRequest.request
  }, [selectedTreeNode])
  /**
   * response form Submission value
   * responsePayload Payload from the
   * @type {function(*, *, *=): {}}
   */
  const formatRequestObj = useCallback((response, responsePayload, editPae) => {
    //Read the contract key from the  form
    const licenseId = response?.contract_id?.id
    const licenseInfoKeys = Object.keys(props.licenseInfo)
    const request = {}
    //Get existing tenant_id if it is edit or create a new one for the ADD
    const editKeys = props.licenseAction === SUBSCRIPTION_ACTION_EDIT ? licenseInfoKeys.includes(APP_ID_PRISMA_ACCESS_EDITION) ?
      props.licenseInfo[APP_ID_PRISMA_ACCESS_EDITION].tenant_id : 'new' : 'new'
    responsePayload?.forEach((each) => {
      const productSelectionKey = [licenseId, ':', each.app_id].join('')
      //Match the licenseId from the quota
      if (each.license_id === licenseId && response[productSelectionKey]) {
        request.license_id = `${each.license_id}`
        request.eula_accepted = response.is_eula_accepted
        request.tsg_name = selectedTreeNode.display_name
        request.app_id = each.app_id
        request.platform = 'cloud'
        request.region = response.region_name.id
        const allocationNotRequired = response ?
          response[licenseId?.concat(':', request.app_id, ':', 'allocation')] === 'false' || props.licenseAction === SUBSCRIPTION_ACTION_EDIT : false
        request.allocation_type = (props.licenseAction === SUBSCRIPTION_ACTION_EDIT && editPae) ? each.allocation_type :
          (each.allocation_type === SHARED ? SHARED : allocationNotRequired ? SHARED : FULL)
        request.quota = []
        request.instances = []
        if (each.app_id === APP_ID_PRISMA_ACCESS_EDITION) {
          const dssUserInput = response[each.license_id.concat(':', 'directory_sync:checkBox')]
          if (apps[APP_ID_DSS_ID] && apps[APP_ID_DSS_ID].enabled && dssUserInput) {
            const instanceObject = {
              'app_id': APP_ID_DSS_ID,
              'tenant_id': props.licenseAction !== SUBSCRIPTION_ACTION_EDIT ? 'new' : props.licenseInfo[APP_ID_DSS_ID]?.tenant_id ?? 'new'
            }
            request.instances.push(instanceObject)
          }
          const paeObject = {
            'app_id': APP_ID_PRISMA_ACCESS,
            'tenant_id': props.licenseAction !== SUBSCRIPTION_ACTION_EDIT ? 'new' : props.licenseInfo[APP_ID_PRISMA_ACCESS]?.tenant_id ?? editKeys,
            'description': response.description
          }
          if (response?.isSpInterconnectRequired) {
            const _backboneRegion = response?.backboneRegion?.length ? response?.backboneRegion?.split(',') : []
            paeObject.backbone_required = response?.isSpInterconnectRequired
            paeObject.backbone_excluded_regions = _backboneRegion.map((each) => each?.trim().toLowerCase())
          }
          if (response[`${each.license_id}:region_name:${APP_ID_PRISMA_ACCESS}`]?.id) {
            paeObject.region = response[`${each.license_id}:region_name:${APP_ID_PRISMA_ACCESS}`]?.id
          }
          request.instances.push(paeObject)
        }
        // const updatedApps = []
        each.parent_remaining.forEach((each, index) => {
          if (!each.app_id) {
            return
          }
          let isAddonDisabled = false
          if (ALLOW_DISABLE_ADDONS.has(each.app_id) && response[each.checkBox] === false) {
            // WARNING: app_id_checkbox can be undefined, need to treat same as true
            isAddonDisabled = true
          }
          const quotaObject = {
            app_id: each.app_id,
            license_type: each.license_type,
            product_type: each.product_type,
            purchased_size: each.purchased_size
          }
          const instanceObject = {
            app_id: each.app_id,
            tenant_id: props.licenseAction !== SUBSCRIPTION_ACTION_EDIT ? 'new' :
              props.licenseInfo[each.app_id] ? props.licenseInfo[each.app_id].tenant_id : 'new',
          }
          if (response[`${request.license_id}:region_name:${each.app_id}`]?.id) {
            instanceObject.region = response[`${request.license_id}:region_name:${each.app_id}`]?.id
          }
          if (URL_VALIDATIONS.includes(each.app_id) && each.formFieldName) {
            instanceObject['subdomain'] = response[each.formFieldName.concat('Url')]?.toLowerCase() || response[each.formFieldName]?.toLowerCase()
            instanceObject['domainPostfix'] = props.domainPostFix[each.app_id]
          }

          if (!URL_VALIDATIONS.includes(each.app_id)) {
            quotaObject.purchased_size = !CALCULATED_FIELDS.includes(each.app_id) ? toNumber((allocationNotRequired &&
                  response[each.formFieldName]) ? response[each.formFieldName] : each.purchased_size) : each.purchased_size
          }
          else {
            quotaObject.purchased_size = each.purchased_size
          }
          if (isAddonDisabled) {
            quotaObject.purchased_size = 0
            quotaObject.is_disabled = true
          }
          request.quota.push(quotaObject)
          // updatedApps.push(quotaObject.app_id)
          if (addNewTenantIdApps.includes(each.app_id) && !groupBy(request.instances, 'app_id')[each.app_id]) {
            request.instances.push(instanceObject)
          }
        })
      }
    })
    return request
  }, [props.licenseInfo, props.licenseAction, props.domainPostFix, selectedTreeNode.display_name, apps])

  const handleSubmit = useCallback(async (values) => {
    setFormLoading(true)
    return new Promise((resolve, reject) => {
      if (values.is_eula_accepted) {
        const isEditInformation = {
          editPae: !!props.licenseInfo?.[APP_ID_PRISMA_ACCESS_EDITION],
          editSdwan: !!props.licenseInfo?.[APP_ID_SDWAN] || props.licenseInfo?.[APP_ID_PRISMA_ACCESS]?._internal?.consumers?.some(each => each.app_id === APP_ID_SDWAN),
          editDSS: props.licenseInfo?.[APP_ID_DSS_ID],
          invokePae: true
        }
        const extractLicense = productInformation?.find((each) => each?.license_id === values?.contract_id?.id)
        // To check whether the edit license is single or full and block the call
        if (isEditInformation.editPae && extractLicense && FULL_ALLOCATION.includes(extractLicense?.allocation_type)) {
          isEditInformation.invokePae = updatedLicenseInfo.includes(selectedTreeNode.id)
        }
        if (!isEditInformation.editDSS && !isEditInformation.invokePae) {
          isEditInformation.invokePae = !!values[values?.contract_id?.id.concat(':', APP_ID_DSS_ID, ':checkBox')]
        }
        const requestObj = isEditInformation?.invokePae && formatRequestObj(values, productInformation, isEditInformation.editPae)
        const submitResponse = []
        const cgxRequestObj = !isEditInformation.editSdwan ? formatCgxRequest(values, cgxProductInfo) : {}
        cgxRequestObj?.license_id && submitResponse.push(SubmitAllocation(selectedTreeNode?.id, cgxRequestObj, isEditInformation.editSdwan))
        requestObj?.license_id && submitResponse.push(SubmitAllocation(selectedTreeNode?.id, requestObj, isEditInformation.editPae))
        Promise.all(submitResponse).then(async (values) => {
          const instanceData = await LoadAllInstanceData([selectedTreeNode?.id], selectedTreeNode?.id, props.dispatch, props.globalDispatch)
          if (instanceData && instanceData.length) {
            props.dispatch(loadInstanceData(instanceData))
          }
          props.setActions(undefined)
          props.dispatch(selectTreeNode(props.sgKeyBy[selectedTreeNode?.id]))
          setCurrentViewing(VIEW_MANAGE_TENANT)
          resolve('Success')
          await LoadInstances({
            tsg_id: selectedTreeNode?.id
          }, props.dispatch)
        }).catch((err) => {
          reject(err)
        })
      }
    })
  }, [props, productInformation, formatRequestObj, formatCgxRequest, cgxProductInfo, selectedTreeNode.id, updatedLicenseInfo])

  const continueModal = useCallback(async (values) => {
    setFormLoading(true)
    await handleSubmit(values)
      .then(() => setShowErrorMsg(false))
      .catch((err) => {
        setErrorMsg(String(err?.message) ?? ALLOCATION_ERROR_MSG)
        setShowErrorMsg(true)
      })
      .finally(() => {
        setFormLoading(false)
        cdlAlertModal.closeModal()
      })
  }, [cdlAlertModal, handleSubmit])

  const openCDLAlertModal = useCallback((values) => {
    cdlAlertModal.openModal({
      title: CDL_ALERT_HEADER,
      continueModal,
      values,
      showClose: true,
      content: CDL_ALERT_CONTENT
    })
  }, [cdlAlertModal, continueModal])

  const updateProductInformation = useCallback((productInfo, cgxProductInfo) => {
    setProductInformation(prev => productInfo ?? prev)
    setCgxProductInfo(prev => cgxProductInfo ?? prev)
  }, [setProductInformation, setCgxProductInfo])

  const cdlUsageAlert = useCallback(async (values) => {
    let allocatedCdl = 0
    const license_id = values['contract_id']?.id
    if (props.licenseAction === SUBSCRIPTION_ACTION_EDIT && props?.licenseInfo[APP_ID_LOGGING_SERVICE]) {
      allocatedCdl = props?.licenseInfo[APP_ID_LOGGING_SERVICE]?.extra?.purchased_size
    }
    const keys = Object.keys(values)
    const cdlKey = keys.find(each => each.includes(APP_ID_LOGGING_SERVICE) && each.includes(license_id) && !each.includes('checkBox'))
    const allocationRequired = keys.find(each => each.includes('allocation'))
    const productInfo = productInformation.find(each => each.license_id === license_id)
    const purchasedCdl = productInfo && productInfo['parent_remaining']?.find(each => each.app_id === APP_ID_LOGGING_SERVICE)
    if (cdlKey && purchasedCdl && values[allocationRequired] === 'false' &&
      toNumber(purchasedCdl.purchased_size + allocatedCdl) === toNumber(values[cdlKey])) {
      openCDLAlertModal(values)
    }
    else {
      await handleSubmit(values)
        .then(() => setShowErrorMsg(false))
        .catch((err) => {
          setErrorMsg(String(err?.message) ?? ALLOCATION_ERROR_MSG)
          setShowErrorMsg(true)
        })
        .finally(() => setFormLoading(false))
    }
  }, [handleSubmit, openCDLAlertModal, productInformation, props.licenseAction, props?.licenseInfo])

  const confirmSubmission = useCallback((values, event) => {
    cdlUsageAlert(values).finally()
  }, [cdlUsageAlert])

  return <>
    {isFormLoading && (
      <div
        className="tw-flex tw-absolute tw-inset-0 tw-justify-center tw-items-center tw-z-50 tw-bg-gray tw-opacity-60">
        <LoadingIcon size="4xl" />
      </div>
    )}
    <Form mode='onBlur' onSubmit={confirmSubmission} formProps={{ autoComplete: 'off' }} >
      <div className='allocation-container tw-h-full tw-w-full tw-absolute'>
        <div className='breadCrumbSection'>
          { showErrorMsg && <div>
            <MessageBanner message={errorMsg} timerInMilliSec={5000} callBack={() => {
              setShowErrorMsg(false)
              setErrorMsg('')
            }
            }/>
          </div>}
          <BreadCrumbs style={{ marginBottom: 5 }} breadcrumbs={breadcrumbs} onClick={onClick}/>
        </div>
        <SubscriptionManagement {...{ ...props, selectedTreeNode, updateProductInformation, apps }}/>
      </div>
    </Form>
  </>
}

SubscriptionForm.propTypes = {}
export default SubscriptionForm
